<template>
  <div>
    <input  class="form-control form-control-sm" v-bind:id="id" v-mask="'##/####'" />
  </div>
</template>

<script>
  import {mask} from 'vue-the-mask'
  export default {
    props: ['id'],
    directives: {mask}
  }
</script>


// WEBPACK FOOTER //
// src/components/utils/InputCompetencia.vue